import Sortable from 'sortablejs';


document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.list-view.rearrange-feature').forEach(function(ul) {
    var sortable = Sortable.create(ul, {
      handle: '.arrange',
      ghostClass: 'ghost',
      onUpdate: function(e) {
        var li = e.item;
        var position = e.newIndex > e.oldIndex ? e.newIndex + 1 : e.newIndex;
        var form = li.querySelector('form');
        var field = form.querySelector('#feature_position');

        field.value = position;
        form.dispatchEvent(new Event('submit', { bubbles: true }));
      }
    });
  });

});
